import {useTranslation} from '@/translations/i18n'
import {useFormContext} from 'react-hook-form'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {
    StyledNewConversationInputText,
    StyledNewConversationTextArea,
    StyledParticipantsDisplay,
    StyledParticipantsText
} from '../new-conversation-form/style'
import {Divider} from '@/components/ui/divider/Divider'
import {
    SelectedItem,
    SelectedItemWithData,
    UserSelectionItem,
    UsersAndGroupsMultiSelectPopover
} from '@/features/users/components/users-and-groups-multi-select-popover/UsersAndGroupsMultiSelectPopover'
import {AvatarGroup} from '@/components/commons/avatar-group/AvatarGroup'
import {PlusIcon} from '@/components/ui/icon/Icon'
import {CombinedItem} from '@/features/users/hooks/useUsersAndGroupsSearchableList'
import {ConversationEntitySelector} from '../conversation-entity-selector/ConversationEntitySelector'

export const NewConversationFields = ({
    selectedItems,
    handleParticipantToggle,
    currentDisplayItems,
    patientId
}: {
    selectedItems: SelectedItem[]
    handleParticipantToggle: (users: UserSelectionItem[], itemData: CombinedItem) => void
    currentDisplayItems: SelectedItemWithData[]
    patientId?: string
}) => {
    const {t} = useTranslation()
    const {register} = useFormContext()

    return (
        <>
            <Flexbox direction="column" gap={2} fullWidth>
                <StyledNewConversationInputText
                    inputSize="lg"
                    type="text"
                    placeholder={t('conversations:title_placeholder')}
                    {...register('title')}
                />
            </Flexbox>
            <Divider direction="horizontal" />
            <Flexbox direction="column" fullWidth>
                <>
                    <UsersAndGroupsMultiSelectPopover
                        currentDisplayItems={currentDisplayItems}
                        selectedItems={selectedItems}
                        toggleClick={handleParticipantToggle}
                        trigger={
                            <StyledParticipantsDisplay
                                type="button"
                                variant="ghost"
                                onMouseDown={e => e.preventDefault()}
                            >
                                {currentDisplayItems.length > 0 ? (
                                    <AvatarGroup>
                                        {currentDisplayItems.slice(0, 3).map(item => (
                                            <AvatarGroup.Item
                                                key={item.id}
                                                name={item.name}
                                                imageUrl={
                                                    item.type === 'user' ? item.avatarUrl || undefined : undefined
                                                }
                                                size="xs"
                                            />
                                        ))}
                                    </AvatarGroup>
                                ) : (
                                    <PlusIcon size={16} />
                                )}

                                <StyledParticipantsText
                                    className={currentDisplayItems.length > 0 ? 'has-selection' : ''}
                                >
                                    {currentDisplayItems.length === 0
                                        ? t('conversations:select_recipients')
                                        : currentDisplayItems.length === 1
                                          ? currentDisplayItems[0].name
                                          : currentDisplayItems.length === 2
                                            ? `${currentDisplayItems[0].name} e ${currentDisplayItems[1].name}`
                                            : `${currentDisplayItems[0].name} e altri ${currentDisplayItems.length - 1}`}
                                </StyledParticipantsText>
                            </StyledParticipantsDisplay>
                        }
                    />
                    {patientId && <ConversationEntitySelector patientId={patientId} />}
                </>
            </Flexbox>
            <Divider direction="horizontal" />
            <Flexbox direction="column" gap={2} fullWidth>
                <StyledNewConversationTextArea
                    placeholder={t('conversations:message_placeholder')}
                    rows={3}
                    {...register('message')}
                />
            </Flexbox>
        </>
    )
}
